export const GuideIcon = () => {
    return (
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.17 18.17">
            <g id="Layer_1-2" data-name="Layer 1">
                <path className="cls-1"
                      d="M9.08,18.17C4.07,18.17,0,14.09,0,9.08S4.07,0,9.08,0s9.08,4.07,9.08,9.08-4.07,9.08-9.08,9.08ZM9.08,1.5C4.9,1.5,1.5,4.9,1.5,9.08s3.4,7.58,7.58,7.58,7.58-3.4,7.58-7.58S13.27,1.5,9.08,1.5Z"/>
                <path className="cls-1"
                      d="M9.08,10.67c-.41,0-.75-.34-.75-.75V5.75c0-.41,.34-.75,.75-.75s.75,.34,.75,.75v4.17c0,.41-.34,.75-.75,.75Z"/>
                <path className="cls-1" d="M9.09,13.42c-.55,0-1-.45-1-1s.44-1,1-1h0c.55,0,1,.45,1,1s-.45,1-1,1Z"/>
            </g>
        </svg>
    );
}